export default __webpack_public_path__ + "static/img/camera-img.eada0aa.jpg";